import React, { useRef, useState, useEffect } from 'react';
import styles from './Monitor.module.scss';
import VideoArea from './VideoArea';
import ActionMenu from './ActionMenu';
import LayerColorInfo from './LayerColorInfo';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_INTERACTIVE_AREAS_STORE, EDITOR_STORE, EDITOR_TIMELINE_STORE } from 'store'
import { OverlayInfoSign, SectionTitle } from 'components/common'
import { MonitorProps } from './types';
import ItemsSection from '../Library/LibraryTab/ItemsSection';
import { InteractiveArea, Product } from 'models'
import { getProductsFromSession } from './VideoArea/InteractiveAreaCanvas/utils';

const Monitor = (props: MonitorProps) => {
  const {
    [EDITOR_STORE]: {
      projectName
    },
    [EDITOR_TIMELINE_STORE]: {
      currentMonitorFrame,
      currentMonitorShotInfo,
      currentMonitorShotLocation
    },
    [EDITOR_INTERACTIVE_AREAS_STORE]: {
      selectedInteractiveAreaIds,
      getInteractiveAreaById
    }
  } = props;

  const containerRef = useRef(null);
  const [offsetTop, setOffsetTop] = useState(0);
  const initialIADetails = {
    id: null,
    videoEntityId: 0,
    interactiveAreaId: null,
    name: '',
    entityId: null,
    entityClass: null,
    shots: [],
    events: []
  }
  const [selectedIADetails, setSelectedIADetails] = useState<InteractiveArea>(initialIADetails)
  console.log('🚀 ---------------------------------------------------🚀')
  console.log('🚀 ~ Monitor ~ selectedIADetails:', selectedIADetails)
  console.log('🚀 ---------------------------------------------------🚀')
  const updateOffsetTop = () => {
    if (containerRef && containerRef.current) {
      setOffsetTop(containerRef.current.offsetTop + containerRef.current.clientHeight);
    }
  };

  useEffect(() => {
    updateOffsetTop();
    window.addEventListener('resize', updateOffsetTop);
    return () => window.removeEventListener('resize', updateOffsetTop);
  }, []);

  // Fetch the pre-load products
  const preloadProductsObj = getProductsFromSession()

  useEffect(() => {
    if (selectedInteractiveAreaIds?.length) {
      const data = getInteractiveAreaById(selectedInteractiveAreaIds[0])
      setSelectedIADetails(data)
    }
    return () => {
      setSelectedIADetails(initialIADetails)
    }
  }, [selectedInteractiveAreaIds])

  return (
    <div className={styles.container} ref={containerRef}>
      <OverlayInfoSign
        text={projectName}
        className={styles.projectName}
      />

      <VideoArea />

      {currentMonitorFrame &&
        <>
          <OverlayInfoSign
            text={currentMonitorFrame}
            className={styles.currentMonitorShotInfo}
            style={{ top: offsetTop - 115, fontSize: '35px' }}
          />
          <OverlayInfoSign
            text={currentMonitorShotInfo}
            className={styles.currentMonitorShotInfo}
            style={{ top: offsetTop - 70 }}

          />
          <OverlayInfoSign
            text={currentMonitorShotLocation || 'location unset'}
            className={
              `${styles.currentMonitorShotInfo}
              ${!currentMonitorShotLocation && styles.locationUnset}`
            }
            style={{ top: offsetTop - 48 }}

          />

          {/* For Auto suggestion products based on the selected Interactive area */}
          {selectedIADetails?.id !== null &&
          <div className={styles.thinScroll} style={{
            position: 'absolute',
            top: 'unset',
            right: 10,
            backgroundColor: 'white',
            zIndex: 999,
            padding: '10px 15px',
            overflowY: 'scroll',
            minHeight: 380,
            minWidth: 215.5
          }}
          >
            {/* Color Info Layer */}
            <LayerColorInfo />

            {selectedIADetails?.name && (
              <>
                <SectionTitle text='brands' />
                {/* Handle when suggestion not available */}
                {
                  !preloadProductsObj[selectedIADetails?.name || ''] && <span style={ { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' } }>Suggestion not available!</span>
                }

                {preloadProductsObj[selectedIADetails?.name || ''] && Object.values(preloadProductsObj[selectedIADetails?.name || ''])?.length && Object.values(preloadProductsObj[selectedIADetails?.name || '']).map((brand, index:number) => (
                  <ItemsSection
                    key={index}
                    items={brand as Array<Product>}
                    label={brand[0]?.brandName}
                  />
                ))}</>
            )}
          </div>}
        </>
      }

      <ActionMenu />
    </div>
  );
};

export default inject(EDITOR_STORE, EDITOR_TIMELINE_STORE, EDITOR_INTERACTIVE_AREAS_STORE)(observer(Monitor));
